import React, { useContext } from "react";

import { SearchContext } from "components/store/source";
import {
  incrementBeds,
  decrementBeds,
  setHighlightListings,
} from "components/store/source/actions/searchCriteriaActions";

import { AmenityCounter } from "./AmenityCounter";

type BedsCounterProps = {
  mobile?: boolean;
};

export function BedsCounter({ mobile = false }: BedsCounterProps) {
  const { dispatch } = useContext(SearchContext);

  const BED_COUNT = "bed_count";

  const incrementBedsCount = () => {
    dispatch(incrementBeds());
    dispatch(setHighlightListings(false));
  };

  const decrementBedsCount = () => {
    dispatch(decrementBeds());
    dispatch(setHighlightListings(false));
  };

  return (
    <AmenityCounter
      incrementCount={incrementBedsCount}
      decrementCount={decrementBedsCount}
      amenity={BED_COUNT}
      mobile={mobile}
    />
  );
}

BedsCounter.displayName = "BedsCounter";
